import React from 'react';
import { useRoutes } from 'react-router-dom';
function lazyLoad(moduleName) {
    return React.lazy(() => import(`src/views/${moduleName}`).then((module) => ({ default: module[moduleName] })));
}
const Intent = lazyLoad('Intent');
const NotFound = lazyLoad('NotFound');
export const Router = () => {
    const mainRoutes = [
        { path: ':id', element: React.createElement(Intent, null) },
        { path: '*', element: React.createElement(NotFound, null) }
    ];
    const routing = useRoutes([...mainRoutes]);
    return React.createElement(React.Fragment, null, routing);
};
